import { PropsWithChildren } from 'react';
import { QueryClientProvider, QueryClient } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

export function ProvideQueryClient({ children }: PropsWithChildren<{}>) {
    const queryClient = new QueryClient();
    return (
        <QueryClientProvider client={queryClient}>
            <>
                {children}
                <ReactQueryDevtools initialIsOpen={false} />
            </>
        </QueryClientProvider>
    );
}
